// src/components/Tutorial/Examples/ProfileDashboard.js
import React from 'react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  Avatar,
  Stack,
  Chip
} from '@mui/material';
import { PersonOutline as PersonIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';

const ProfileDashboard = () => {
  return (
    <Box className="example-container" sx={{ mt: 3 }}>
      <Card sx={{ 
        borderRadius: 3, 
        overflow: 'hidden', 
        boxShadow: 3,
      }}>
        <Box
          sx={{
            background: 'linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)',
            p: 4,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* Decorative pattern */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '40%',
              height: '100%',
              opacity: 0.1,
              background: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.1) 10px, rgba(255,255,255,0.1) 20px)',
            }}
          />
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, position: 'relative', flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
            <Avatar
              sx={{
                width: { xs: 80, sm: 100 },
                height: { xs: 80, sm: 100 },
                border: '4px solid rgba(255, 255, 255, 0.3)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
              }}
            >
              👤
            </Avatar>
            
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1, flexWrap: 'wrap' }}>
                <Typography variant="h4" fontWeight={700} sx={{ color: 'white', textShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
                  Example User
                </Typography>
                <Chip
                  icon={<CheckCircleIcon sx={{ color: 'white !important', fontSize: '1rem' }} />}
                  label="OF VERIFIED"
                  size="small"
                  sx={{
                    background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                    color: 'white',
                    fontWeight: 700,
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 4px 12px rgba(76, 175, 80, 0.4)',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    '& .MuiChip-label': {
                      px: 1.5,
                    },
                  }}
                />
              </Box>
              <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}>
                Welcome to OnlyStats! Start reviewing your subscriptions.
              </Typography>
              <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap', gap: 2 }}>
                <Button
                  variant="contained"
                  startIcon={<PersonIcon />}
                  sx={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)',
                    color: 'white',
                    fontWeight: 600,
                    '&:hover': {
                      background: 'rgba(255, 255, 255, 0.3)',
                    },
                  }}
                >
                  Edit Profile
                </Button>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default ProfileDashboard;
